<script setup lang="ts">
import { FileCheck2, HandCoins, ShieldCheck } from "lucide-vue-next";

const items = [
  {
    icon: FileCheck2,
    title: "worker_profile.safety_scope_title",
    text: "worker_profile.safety_scope_text",
  },
  {
    icon: HandCoins,
    title: "worker_profile.safety_payment_title",
    text: "worker_profile.safety_payment_text",
  },
  {
    icon: ShieldCheck,
    title: "worker_profile.safety_records_title",
    text: "worker_profile.safety_records_text",
  },
];
</script>

<template>
  <section role="note">
    <div
      class="grid overflow-hidden rounded-2xl border border-app-border bg-white shadow-[0_1px_2px_rgba(16,24,40,0.03)] md:grid-cols-3"
    >
      <article
        v-for="(item, index) in items"
        :key="item.title"
        class="px-6 py-7 text-center md:px-8 md:py-9"
        :class="
          index ? 'border-t border-app-border md:border-l md:border-t-0' : ''
        "
      >
        <component
          :is="item.icon"
          class="mx-auto size-9 stroke-[1.7] text-app-text md:size-10"
          aria-hidden="true"
        />
        <h3 class="mt-4 text-base font-bold leading-5 text-app-text">
          {{ $t(item.title) }}
        </h3>
        <p
          class="mx-auto mt-2 max-w-[350px] text-sm leading-6 text-app-muted md:text-base"
        >
          {{ $t(item.text) }}
        </p>
      </article>
    </div>
  </section>
</template>
